import React from "react";
import styles from "./Footer.module.css";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import history from "core/helper/Helper";
import { RouterName } from "shared/RouterName";

const Footer = () => {
  const handleToReturnPoliciesPage = () => {
    history.push(RouterName.ReturnPolicies.url);
  };
  const handleToReturnDeliveryAndPaymentPage = () => {
    history.push(RouterName.DeliveryAndPayment.url);
  };
  return (
    <div className={styles.footer}>
      <Grid container spacing={0}>
        <Grid item xs={12} sm={3} className={styles.footer_item}>
          <img
            style={{ width: "50%" }}
            src={process.env.PUBLIC_URL + "/logo192.png"}
          />
        </Grid>
        <Grid item xs={12} sm={4} className={styles.footer_item}>
          <Typography variant="h6" gutterBottom>
            Liên Hệ
          </Typography>
          <Typography variant="body1" gutterBottom>
            SHOP PHONG THỦY KUNLEZ
          </Typography>
          <Typography variant="body1" gutterBottom>
            HOTLINE: 0387923479 | 0382189922
          </Typography>
          <Typography variant="body1" gutterBottom>
            kunlez.web.app
          </Typography>
          <Typography variant="body1" gutterBottom>
            ĐC: Trần Hưng Đạo, Điện Ngọc, Điện Bàn, Quảng Nam, Viet Nam
          </Typography>
        </Grid>
        <Grid item xs={12} sm={5} className={styles.footer_item}>
          <Grid item xs={12} sm={6}>
            <Typography variant="h6" gutterBottom>
              Hỗ Trợ Khách Hàng
            </Typography>
            <Typography variant="body1" gutterBottom>
              Hotline đặt hàng: 0382189922
            </Typography>
            <Typography variant="body1" gutterBottom>
              HotLine tư vấn: 0387923479
            </Typography>
            <Typography
              variant="body1"
              gutterBottom
              onClick={handleToReturnPoliciesPage}
              style={{ cursor: "pointer" }}
            >
              Chính sách đổi trả
            </Typography>
            <Typography
              variant="body1"
              gutterBottom
              onClick={handleToReturnDeliveryAndPaymentPage}
              style={{ cursor: "pointer" }}
            >
              Chính sách giao hàng và thanh toán
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <div style={{ padding: "30px" }}>Copyright 2020 © KunlezIsme</div>
    </div>
  );
};

export default Footer;
